export default __webpack_public_path__ + "13b6a17c7e122bdc1496bb3ac81c349a.png";